import { lazy } from "react";
import { ADMIN_ROLE } from "./routeConfig";

const adminRoutes = [
  {
    path: "/admin/dashboard",
    component: lazy(() => import("../Pages/Admin/Dashboard")),
    isPublic: false,
    exact: true,
    role: [ADMIN_ROLE],
  },
  {
    path: "/admin/practices",
    component: lazy(() => import("../Pages/Admin/Practices")),
    isPublic: false,
    exact: true,
    role: [ADMIN_ROLE],
  },
  {
    path: "/admin/practice/:practiceId/financing-options",
    component: lazy(() => import("../Pages/Admin/PracticeFinancingOptions")),
    isPublic: false,
    exact: true,
    role: [ADMIN_ROLE],
  },
  {
    path: "/admin/practice/:practiceId/insurance-plan-blacklist",
    component: lazy(() => import("../Pages/Admin/InsurancePlanBlacklist")),
    isPublic: false,
    exact: true,
    role: [ADMIN_ROLE],
  },
  {
    path: "/admin/practice/:practiceId/insurance-plan-audit",
    component: lazy(() => import("../Pages/Admin/InsurancePlanAudit")),
    isPublic: false,
    exact: true,
    role: [ADMIN_ROLE],
  },
  {
    path: "/admin/practice/:practiceId/recall-audit",
    component: lazy(() => import("../Pages/Admin/RecallAudit")),
    isPublic: false,
    exact: true,
    role: [ADMIN_ROLE],
  },
  {
    path: "/admin/doctors",
    component: lazy(() => import("../Pages/Admin/Doctors")),
    isPublic: false,
    exact: true,
    role: [ADMIN_ROLE],
  },
  {
    path: "/admin/engagement",
    component: lazy(() => import("../Pages/Admin/Engagement")),
    isPublic: false,
    exact: true,
    role: [ADMIN_ROLE],
  },
  {
    path: "/admin/system-prompts",
    component: lazy(() => import("../Pages/Admin/SystemPrompts")),
    isPublic: false,
    exact: true,
    role: [ADMIN_ROLE],
  },
  {
    path: "/admin/financing-partners",
    component: lazy(() => import("../Pages/Admin/FinancingPartners")),
    isPublic: false,
    exact: true,
    role: [ADMIN_ROLE],
  },
];

export default adminRoutes;
